module.exports = __webpack_public_path__ + "static/media/all_brands_banner_img.d7f707ff.png";